<template>
  <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">
    <div class="bg-red-50" v-if="errors.load">
      {{ errors.load }}
    </div>

    <Loader v-if="loading" />

    <div v-else-if="data.department.id" class="mb-16">
      <PageTitle v-bind:title="title" v-bind:admin="false" />

      <div class="relative bg-white py-16 sm:py-24">
        <div
          class="lg:mx-auto lg:max-w-7xl lg:px-8 lg:grid lg:grid-cols-2 lg:gap-24 lg:items-start"
        >
          <div class="relative sm:py-16 lg:py-0">
            <div
              aria-hidden="true"
              class="hidden sm:block lg:absolute lg:inset-y-0 lg:right-0 lg:w-screen"
            >
              <div
                class="absolute inset-y-0 right-1/2 w-full bg-gray-50 rounded-r-3xl lg:right-72"
              ></div>
              <svg
                class="absolute top-8 left-1/2 -ml-3 lg:-right-8 lg:left-auto lg:top-12"
                width="404"
                height="392"
                fill="none"
                viewBox="0 0 404 392"
              >
                <defs>
                  <pattern
                    id="02f20b47-fd69-4224-a62a-4c9de5c763f7"
                    x="0"
                    y="0"
                    width="20"
                    height="20"
                    patternUnits="userSpaceOnUse"
                  >
                    <rect
                      x="0"
                      y="0"
                      width="4"
                      height="4"
                      class="text-gray-200"
                      fill="currentColor"
                    />
                  </pattern>
                </defs>
                <rect
                  width="404"
                  height="392"
                  fill="url(#02f20b47-fd69-4224-a62a-4c9de5c763f7)"
                />
              </svg>
            </div>
            <div
              class="relative mx-auto max-w-md px-4 sm:max-w-3xl sm:px-6 lg:px-0 lg:max-w-none lg:py-20"
            >
              <!-- Testimonial card-->
              <div
                class="relative pt-64 pb-10 rounded-2xl shadow-xl overflow-hidden"
              >
                <!--
                <img
                  v-if="data.department.image"
                  :src="data.department.image"
                  class="absolute inset-0 h-full w-full object-cover"
                  alt=""
                />
                -->
                <img
                  v-if="data.department.image"
                  :src="data.department.image"
                  class="absolute inset-0 "
                  alt=""
                />
                <div
                  class="absolute inset-0 bg-indigo-50"
                  style="mix-blend-mode: multiply"
                ></div>
                <div
                  class="absolute inset-0 bg-gradient-to-t from-indigo-600 via-indigo-600 opacity-90"
                ></div>
                <div class="relative px-8">
                  <div class="h-12">
                    <!-- <img
                      class="h-12"
                      src="https://tailwindui.com/img/logos/workcation.svg?color=white"
                      alt=""
                    /> -->
                  </div>
                  <!-- <blockquote class="mt-8">
                    <div
                      class="relative text-lg font-medium text-white md:flex-grow"
                    >
                      <svg
                        class="absolute top-0 left-0 transform -translate-x-3 -translate-y-2 h-8 w-8 text-indigo-400"
                        fill="currentColor"
                        viewBox="0 0 32 32"
                        aria-hidden="true"
                      >
                        <path
                          d="M9.352 4C4.456 7.456 1 13.12 1 19.36c0 5.088 3.072 8.064 6.624 8.064 3.36 0 5.856-2.688 5.856-5.856 0-3.168-2.208-5.472-5.088-5.472-.576 0-1.344.096-1.536.192.48-3.264 3.552-7.104 6.624-9.024L9.352 4zm16.512 0c-4.8 3.456-8.256 9.12-8.256 15.36 0 5.088 3.072 8.064 6.624 8.064 3.264 0 5.856-2.688 5.856-5.856 0-3.168-2.304-5.472-5.184-5.472-.576 0-1.248.096-1.44.192.48-3.264 3.456-7.104 6.528-9.024L25.864 4z"
                        />
                      </svg>
                      <p class="relative">
                        Tincidunt integer commodo, cursus etiam aliquam neque,
                        et. Consectetur pretium in volutpat, diam. Montes, magna
                        cursus nulla feugiat dignissim id lobortis amet.
                      </p>
                    </div>

                    <footer class="mt-4">
                      <p class="text-base font-semibold text-indigo-200">
                        Sarah Williams, CEO at Workcation
                      </p>
                    </footer>
                  </blockquote> -->
                </div>
              </div>
            </div>
          </div>

          <div
            class="relative mx-auto max-w-md px-4 sm:max-w-3xl sm:px-6 lg:px-0"
          >
            <!-- Content area -->
            <div class="pt-12 sm:pt-16 lg:pt-20">
              <h2
                class="text-3xl text-gray-900 font-extrabold tracking-tight sm:text-4xl"
              >
                Описание
              </h2>
              <div class="mt-6 text-gray-500 space-y-6">
                <!--
                <p class="text-base leading-7" >
                  {{ data.department.description }}
                </p>
                -->
                <p class="text-base leading-7" v-html="brFunc(data.department.description)">

                </p>
              </div>
            </div>

            <!-- Stats section -->
            <!-- <div class="mt-10">
              <dl class="grid grid-cols-2 gap-x-4 gap-y-8">
                <div class="border-t-2 border-gray-100 pt-6">
                  <dt class="text-base font-medium text-gray-500">Founded</dt>
                  <dd
                    class="text-3xl font-extrabold tracking-tight text-gray-900"
                  >
                    2021
                  </dd>
                </div>

                <div class="border-t-2 border-gray-100 pt-6">
                  <dt class="text-base font-medium text-gray-500">Employees</dt>
                  <dd
                    class="text-3xl font-extrabold tracking-tight text-gray-900"
                  >
                    5
                  </dd>
                </div>

                <div class="border-t-2 border-gray-100 pt-6">
                  <dt class="text-base font-medium text-gray-500">
                    Beta Users
                  </dt>
                  <dd
                    class="text-3xl font-extrabold tracking-tight text-gray-900"
                  >
                    521
                  </dd>
                </div>

                <div class="border-t-2 border-gray-100 pt-6">
                  <dt class="text-base font-medium text-gray-500">Raised</dt>
                  <dd
                    class="text-3xl font-extrabold tracking-tight text-gray-900"
                  >
                    $25M
                  </dd>
                </div>
              </dl>
              <div class="mt-10">
                <a href="#" class="text-base font-medium text-indigo-600">
                  Learn more about how we're changing the world
                  <span aria-hidden="true">&rarr;</span>
                </a>
              </div>
            </div> -->
          </div>
        </div>
      </div>

      <template v-if="data.courses.length > 0">
        <h3 class="my-4 text-lg font-bold">Список курсов кафедры:</h3>
        <div class="flex flex-col">
          <div class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
            <div
              class="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8"
            >
              <div
                class="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg"
              >
                <table class="min-w-full divide-y divide-gray-200">
                  <thead class="bg-gray-50">
                    <tr>
                      <th
                        v-if="true"
                        scope="col"
                        class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                      >
                        ID
                      </th>
                      <th
                        scope="col"
                        class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider"
                      >
                        Наименование
                      </th>
                    </tr>
                  </thead>
                  <tbody class="bg-white divide-y divide-gray-200">
                    <tr v-for="item in data.courses" :key="item.id">
                      <td
                        v-if="true"
                        class="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900"
                      >
                        {{ item.id }}
                      </td>
                      <td
                        class="px-6 py-4 whitespace-nowrap text-sm text-gray-500"
                      >
                        <router-link
                          :to="{ name: 'course_show', params: { id: item.id } }"
                          >{{ item.name }}</router-link
                        >
                        <span v-if="item.status_id == 5">отвечен</span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </template>
      <!--
      <template v-else>
        <div class="bg-red-100" role="alert">
          У этой кафедры ещё нет Курсов!
        </div>
      </template>
      -->
    </div>
  </div>
</template>
<script>
import axios from "axios";
import Loader from "@/components/Loader";
import PageTitle from "@/components/PageTitle";
//import jQuery from 'jquery'
export default {
  data() {
    return {
      loading: true,
      data: [],
      errors: { load: "" },
      title: "",
    };
  },
  async mounted() {
    this.loadData();
  },
  methods: {


    //
    // Переносы из textarea конвертим в переносы для абзаца.
    //
    brFunc(str) {
      if (str) {
        return str.replace(/\n/g, "<br />");
      }
    },


    async loadData() {
      this.errors.load = "";
      try {
        this.loading = true;
        let response = await axios.get("departments/" + this.$route.params.id);
        this.data = response.data;
        this.title = this.data.department.name;
        this.loading = false;
      } catch (e) {
        this.errors.load = "Ошибка при загрузке данных";
      }
    },
  },

  components: {
    Loader,
    PageTitle,
  },
};
</script>